export default {
  NOTLOADED: 'notloaded',
  LOADING: 'loading',
  LOADED: 'loaded'
}
